export default __webpack_public_path__ + "2bc45a5aef833b8beb74d47c5dc0ce58.png";